import { render, staticRenderFns } from "./bid-item.vue?vue&type=template&id=5d11eee3&"
import script from "./bid-item.vue?vue&type=script&lang=js&"
export * from "./bid-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports